import { computed, ref } from 'vue'
import { useTemplateStore } from 'src/stores'
import { TemplateBackgroundTypeEnum } from 'src/common/enums'

export default function useBaseTemplateMainSectionHook(props) {
  const templateStore = useTemplateStore()
  const currentDate = Date.now()

  const isLayerMovingRef = ref(false)
  const isLayerActiveRef = computed(() => templateStore.activeLayer.index === props.layerIndex)

  const backgroundStyle = computed(() =>
    templateStore.isDigitalMenu
      ? templateStore.backgroundType === TemplateBackgroundTypeEnum.COLOR
        ? `background-color: ${templateStore.background}`
        : `background: url(${typeof templateStore.background === 'string' ? `${templateStore.background}?t=${Date.now()}` : templateStore.background.blob}) center center / cover no-repeat`
      : '',
  )

  // Track drag start position and initial item positions for accurate delta movement
  let dragStartClientX = 0
  let dragStartClientY = 0
  let dragStartPositions = {}

  function handleItemMoveStart(item, $event) {
    templateStore.handleActiveLayer({
      index: props.layerIndex,
      id: props.layer.id,
      updatedFrom: 'section',
    })

    // If this item is already part of a multi-select, preserve the selection.
    // Otherwise select only this item.
    if (!templateStore.selectedItemIds.includes(item.id)) {
      templateStore.handleActiveItem(item)
    }

    dragStartClientX = $event?.clientX || 0
    dragStartClientY = $event?.clientY || 0
    dragStartPositions = {}

    const idsToMove = templateStore.selectedItemIds.length > 0 ? templateStore.selectedItemIds : [item.id]
    for (const layer of templateStore.layers) {
      for (const layerItem of layer.items) {
        if (idsToMove.includes(layerItem.id)) {
          dragStartPositions[layerItem.id] = {
            x: layerItem.start_position.x,
            y: layerItem.start_position.y,
          }
        }
      }
    }

    templateStore.isDragging = true
  }

  function handleResize($event) {
    if ($event.type !== 'dragend') isLayerMovingRef.value = true

    templateStore.handleActiveLayer({
      index: props.layerIndex,
      id: props.layer.id,
      updatedFrom: 'section',
    })
    if ($event.screenX) {
      const elementHeight = $event.srcElement.getBoundingClientRect().height
      const height = props.layer.height + $event.layerY - elementHeight
      templateStore.handleResizeLayer({
        layerIndex: props.layerIndex,
        height: height > 0 ? height : 0,
      })
    }

    if ($event.type === 'dragend') isLayerMovingRef.value = false
  }

  function handleItemMove($event) {
    if ($event.screenX) {
      const htmlElement = document.documentElement
      const zoomLevel = Number(window.getComputedStyle(htmlElement).getPropertyValue('--zoom')) || 1

      // Compute true delta from drag origin — accurate regardless of element position
      const dx = ($event.clientX - dragStartClientX) / zoomLevel
      const dy = ($event.clientY - dragStartClientY) / zoomLevel

      const positions = {}
      for (const [id, startPos] of Object.entries(dragStartPositions)) {
        positions[Number(id)] = { x: startPos.x + dx, y: startPos.y + dy }
      }
      templateStore.moveSelectedItemsTo(positions)
    }

    if ($event.type === 'dragend') {
      templateStore.isDragging = false
      if (Object.keys(dragStartPositions).length > 0) {
        templateStore._pushHistory()
      }
      dragStartPositions = {}
    }
  }

  return {
    templateStore,
    currentDate,
    isLayerMovingRef,
    isLayerActiveRef,
    backgroundStyle,
    handleResize,
    handleItemMove,
    handleItemMoveStart,
  }
}
